import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {useNavigation} from '@react-navigation/native';

import {REQUEST_TYPES} from '~/types/request';
import {useDispatch, useThrottledCallback} from '~/lib/hooks';
import {
  fleet as fleetApi,
  rob as robApi,
  service_request as serviceRequestApi,
} from '~/api/private';

import ServiceRequestContext from '../context';
const withServiceRequestContext = (Component) => {
  const WithServiceRequestContext = (props) => {
    const {request_id} = props.route.params ?? {};

    const navigation = useNavigation();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [request, setRequest] = useState({});
    const [isFleetCar, setIsFleetCar] = useState(false);
    const [replacement, setReplacement] = useState(null);
    const [rob, setRob] = useState(null);
    const [fleetRequest, setFleetRequest] = useState(null);
    const [readLastMessage, setReadLastMessage] = useState(true);

    const refresh = useThrottledCallback(async () => {
      try {
        const {result} = await serviceRequestApi.get(request_id, dispatch);
        if (!result.length) {
          navigation.replace('Tabs', {
            screen: 'Calendar',
          });
          return false;
        }

        setRequest(result[0]);

        if (
          result[0].request_type === REQUEST_TYPES.FLEET_REQUEST ||
          result[0].request_type === REQUEST_TYPES.FLEET_REPLACEMENT_VEHICLE
        ) {
          const {result: replacement_vehicle} =
            await fleetApi.replacement_vehicle(request_id);

          setReplacement(replacement_vehicle.replacement);
          setFleetRequest(replacement_vehicle.fleet_request);
          setIsFleetCar(true);
        } else if (
          result[0].request_type === REQUEST_TYPES.ROB_REQUEST ||
          result[0].request_type === REQUEST_TYPES.ROB_REPLACEMENT_VEHICLE
        ) {
          const {result: replacement_vehicle} =
            await robApi.replacement_vehicle(request_id);

          setReplacement(replacement_vehicle.replacement);
          setRob(replacement_vehicle.rob);
          setIsFleetCar(false);
        }
      } finally {
        setLoading(false);
      }
    }, [request_id, dispatch]);

    useEffect(() => {
      if (replacement?.last_message) {
        setReadLastMessage(replacement.last_message?.is_read ?? true);
      }
    }, [replacement]);

    const contextValue = useMemo(
      () => ({
        request_id,
        loading,
        request,
        is_fleet_car: isFleetCar,
        replacement,
        rob,
        fleetRequest,
        readLastMessage,

        onRefresh: refresh,
      }),
      [
        request_id,
        loading,
        request,
        isFleetCar,
        replacement,
        rob,
        fleetRequest,
        readLastMessage,
        refresh,
      ],
    );

    return (
      <ServiceRequestContext.Provider value={contextValue}>
        <Component {...props} />
      </ServiceRequestContext.Provider>
    );
  };

  WithServiceRequestContext.propTypes = {
    route: PropTypes.shape({
      params: PropTypes.object,
    }),
  };

  return WithServiceRequestContext;
};

export default withServiceRequestContext;
